import { render } from "./TicketsPage.vue?vue&type=template&id=33eaf178&ts=true"
import script from "./TicketsPage.vue?vue&type=script&lang=ts"
export * from "./TicketsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__